import {  useEffect, useState } from "react";
// import { useHistory } from 'react-router-dom'

// context
import { useAuthContext } from "./useAuthContext";
import { projectAuth, projectFirestore } from "../Firebase/Config";

export const useAuthLogout = () => {
    const [isCancelled, setIsCancelled] = useState(false);
    const [error, setError] = useState(null)
    const [isPending, setIsPending] = useState(false);
    const { dispatch, user } = useAuthContext()
    
    // const history = useHistory()

    const logout = async() => {
        setError(null)
        setIsPending(true)
        try {
            // update online status
            const { uid } = user
            await projectFirestore.collection('users').doc(uid).update({ online: false })

            await projectAuth.signOut()
            // dispatch logout
            dispatch({ type: 'LOGOUT' })


            // update state
            if(!isCancelled){
                setIsPending(false)
                setError(null)
                // history.push('/login')
            }
            

        }catch (err) {
            if(!isCancelled){
                setError(err.message)
                setIsPending(false)
            }
        }
    }

    useEffect(() => {
        return () => setIsCancelled(true);
    },[])

    return { logout, error, isPending }
}